import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Actions from '../../actions';
import APP_ACTIONS from '../../constants/app-actions';
import DeliveryForm from '../../components/checkout-steps/delivery-form';
import CheckoutStepCalculator from '../../services/checkout-step-calculator';
import APP_ROUTES from '../../constants/app-routes';
import loader from '../../actions/loader';

const mapStateToProps = (state, ownProps) => ({
    order: state.order,
    stores: state.stores.stores,
    locale: state.locale,
    placedOrder: state.placedOrder,
    displayLoader: state.displayLoader,
    hasExtraTimeCheckout: state.cartState.hasExtraTimeCheckout,
    gracePeriod: state.cartState.gracePeriod,
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentCheckoutStep: () => {
        dispatch({
            type: APP_ACTIONS.SET_CURRENT_CHECKOUT_STEP,
            payload: 'delivery',
        });
        dispatch(loader.hideLoader());
    },

    handleDeliveryFormSubmit: (formData, order, locale) => dispatch(Actions.goToNextStep(order, locale, formData)),

    handleCheckoutStepNotEditable: (order, placedOrder) => {
    /* Redirect to last step if order is already placed */
        if (placedOrder.id) {
            dispatch(push(APP_ROUTES.checkout[`${placedOrder.checkout_steps.slice(-1)}PageRoute`]));
        } else if (order.id) {
            const previousStep = CheckoutStepCalculator.previous(order.checkout_steps, 'delivery');

            dispatch(push(APP_ROUTES.checkout[`${previousStep}PageRoute`]));
        }
    },

    redirectToCart: () => dispatch(push(APP_ROUTES.cartPageRoute)),
});

const DeliveryFormConnector = connect(mapStateToProps, mapDispatchToProps)(DeliveryForm);

export default DeliveryFormConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/checkout-steps/delivery-form-connector.js
 **/